export enum DialogType {
  Dialog = 'dialog',
  Popup = 'popup',
  NewMessage = 'new-message',
}
